import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7568a06e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["selected", "offline", "duplicate-license", "incompatible-version", "in-progress", "floating", "cloud-stopped"]

import { Agent, Agent_Status } from '@/graphql/codegen/generated/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentTableCellWrapper',
  props: {
    agentMetadata: null,
    selected: { type: Boolean },
    floating: { type: Boolean },
    status: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "agents-table--cell-wrapper",
    selected: __props.selected,
    offline: __props.agentMetadata?.isOffline,
    "duplicate-license": __props.agentMetadata?.isDuplicateLicense,
    "incompatible-version": __props.agentMetadata?.isIncompatibleVersion,
    "in-progress": __props.agentMetadata?.isInProgress,
    floating: __props.floating,
    "cloud-stopped": __props.agentMetadata?.isCloud && __props.status === _unref(Agent_Status).Stopped
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})